import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["classes", "className", "toolbar", "edsContext"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import React, { useState, useMemo, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactQuill, { Quill } from 'react-quill';
import Delta from 'quill-delta';
import cn from 'classnames';
import { withEDSContext } from '../EDSContext/EDSContext';
import styles from './styles/react-quill-snow';
import renderToHTML from './internal/renderToHTML';
import { withStyles } from '../styles';
import AlignCenterIcon from '@ellucian/ds-icons/lib/AlignCenter';
import AlignJustifyIcon from '@ellucian/ds-icons/lib/AlignJustify';
import AlignLeftIcon from '@ellucian/ds-icons/lib/AlignLeft';
import AlignRightIcon from '@ellucian/ds-icons/lib/AlignRight';
import BlockquoteIcon from '@ellucian/ds-icons/lib/QuoteRight';
import BoldIcon from '@ellucian/ds-icons/lib/Bold';
import ClearFormattingIcon from '@ellucian/ds-icons/lib/ClearFormatting';
import DirectionIcon from '@ellucian/ds-icons/lib/Direction';
import DirectionRTLIcon from '@ellucian/ds-icons/lib/DirectionRtl';
import FontColorIcon from '@ellucian/ds-icons/lib/Font';
import IndentIcon from '@ellucian/ds-icons/lib/Indent';
import ImageIcon from '@ellucian/ds-icons/lib/Image';
import ItalicIcon from '@ellucian/ds-icons/lib/Italic';
import LinkIcon from '@ellucian/ds-icons/lib/Link';
import OrderedListIcon from '@ellucian/ds-icons/lib/ListOl';
import OutdentIcon from '@ellucian/ds-icons/lib/Outdent';
import StrikethroughIcon from '@ellucian/ds-icons/lib/Strikethrough';
import SubscriptIcon from '@ellucian/ds-icons/lib/Subscript';
import SuperscriptIcon from '@ellucian/ds-icons/lib/Superscript';
import UnderlineIcon from '@ellucian/ds-icons/lib/Underline';
import UndoIcon from '@ellucian/ds-icons/lib/Undo';
import UnorderedListIcon from '@ellucian/ds-icons/lib/ListView';
import VideoIcon from '@ellucian/ds-icons/lib/Video';
import RedoIcon from '@ellucian/ds-icons/lib/Redo';
import LinkPopper from './internal/LinkPopper';
import ImagePopper from './internal/ImagePopper';
import ImageResize from './internal/QuillImageResizer/ImageResize';
import VideoPopper from './internal/VideoPopper';
import CustomHeader from './blots/CustomHeaderBlot';
import CustomLink from './blots/LinkBlot';
import CustomImage from './blots/CustomImageBlot';
import CustomVideo from './blots/CustomVideoBlot';

// override Quill's formats and modules with our own custom implementations
Quill.debug('error');
Quill.register('modules/imageResize', ImageResize);
Quill.register('formats/header', CustomHeader);
Quill.register('formats/link', CustomLink);
Quill.register('formats/image', CustomImage);
Quill.register('formats/video', CustomVideo);
var icons = Quill.import('ui/icons');
var defaultToolbar = [[{
  'header': ['h1', 'h2', 'h3', 'body1', 'body2', 'body3', 'caption', false]
}], ['bold', 'italic', 'underline', 'strike'], [{
  'color': ['#151618', '#5B5E65', '#00834F', '#D42828', '#BA46A6', '#5353D1']
}], [{
  'script': 'sub'
}, {
  'script': 'super'
}, 'blockquote'], [{
  align: ''
}, {
  align: 'center'
}, {
  align: 'right'
}, {
  align: 'justify'
}], [{
  'list': 'bullet'
}, {
  'list': 'ordered'
}], [{
  'indent': '-1'
}, {
  'indent': '+1'
}, {
  'direction': 'rtl'
}], ['link', 'image', 'video'], ['clean'], [{
  'history': 'undo'
}, {
  'history': 'redo'
}]];

/**
 * A component that enables users to create rich textual content.
 * @done true
 * @updated v7.5.0
 * @versionAdded v7.2.0
 * @examples
 *  RichTextEditorExample
 *  InADialog
 *  WithCustomToolbar
 *  MinimumHeight
 *  WithRichTextRenderer
 */
var RichTextEditor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useState = useState(false),
    iconsLoaded = _useState[0],
    setIconsLoaded = _useState[1];
  var classes = props.classes,
    className = props.className,
    toolbarProp = props.toolbar,
    edsContext = props.edsContext,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var dir = edsContext.dir;
  var quillRef = ref || useRef(); //eslint-disable-line react-hooks/rules-of-hooks

  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var alignHTML, alignCenterHTML, alignJustifyHTML, alignRightHTML, blockquoteHTML, boldHTML, clearFormattingHTML, directionHTML, directionRTLHTML, fontColorHTML, imageHTML, indentHTML, italicHTML, linkHTML, orderedListHTML, outdentHTML, redoHTML, strikethroughHTML, superscriptHTML, subscriptHTML, underlineHTML, undoHTML, unorderedListHTML, videoHTML;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return renderToHTML(AlignLeftIcon);
          case 2:
            alignHTML = _context.sent;
            _context.next = 5;
            return renderToHTML(AlignCenterIcon);
          case 5:
            alignCenterHTML = _context.sent;
            _context.next = 8;
            return renderToHTML(AlignJustifyIcon);
          case 8:
            alignJustifyHTML = _context.sent;
            _context.next = 11;
            return renderToHTML(AlignRightIcon);
          case 11:
            alignRightHTML = _context.sent;
            _context.next = 14;
            return renderToHTML(BlockquoteIcon);
          case 14:
            blockquoteHTML = _context.sent;
            _context.next = 17;
            return renderToHTML(BoldIcon);
          case 17:
            boldHTML = _context.sent;
            _context.next = 20;
            return renderToHTML(ClearFormattingIcon);
          case 20:
            clearFormattingHTML = _context.sent;
            _context.next = 23;
            return renderToHTML(DirectionIcon);
          case 23:
            directionHTML = _context.sent;
            _context.next = 26;
            return renderToHTML(DirectionRTLIcon);
          case 26:
            directionRTLHTML = _context.sent;
            _context.next = 29;
            return renderToHTML(FontColorIcon);
          case 29:
            fontColorHTML = _context.sent;
            _context.next = 32;
            return renderToHTML(ImageIcon);
          case 32:
            imageHTML = _context.sent;
            _context.next = 35;
            return renderToHTML(IndentIcon);
          case 35:
            indentHTML = _context.sent;
            _context.next = 38;
            return renderToHTML(ItalicIcon);
          case 38:
            italicHTML = _context.sent;
            _context.next = 41;
            return renderToHTML(LinkIcon);
          case 41:
            linkHTML = _context.sent;
            _context.next = 44;
            return renderToHTML(OrderedListIcon);
          case 44:
            orderedListHTML = _context.sent;
            _context.next = 47;
            return renderToHTML(OutdentIcon);
          case 47:
            outdentHTML = _context.sent;
            _context.next = 50;
            return renderToHTML(RedoIcon);
          case 50:
            redoHTML = _context.sent;
            _context.next = 53;
            return renderToHTML(StrikethroughIcon);
          case 53:
            strikethroughHTML = _context.sent;
            _context.next = 56;
            return renderToHTML(SuperscriptIcon);
          case 56:
            superscriptHTML = _context.sent;
            _context.next = 59;
            return renderToHTML(SubscriptIcon);
          case 59:
            subscriptHTML = _context.sent;
            _context.next = 62;
            return renderToHTML(UnderlineIcon);
          case 62:
            underlineHTML = _context.sent;
            _context.next = 65;
            return renderToHTML(UndoIcon);
          case 65:
            undoHTML = _context.sent;
            _context.next = 68;
            return renderToHTML(UnorderedListIcon);
          case 68:
            unorderedListHTML = _context.sent;
            _context.next = 71;
            return renderToHTML(VideoIcon);
          case 71:
            videoHTML = _context.sent;
            icons.align['right'] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.alignRight') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.alignRight') + "\">" + alignRightHTML + "</span>";
            icons.align['center'] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.alignCenter') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.alignCenter') + "\">" + alignCenterHTML + "</span>";
            icons.align['justify'] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.alignJustify') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.alignJustify') + "\">" + alignJustifyHTML + "</span>";
            icons.align[''] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.alignLeft') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.alignLeft') + "\">" + alignHTML + "</span>";
            icons.blockquote = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.blockquote') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.blockquote') + "\">" + blockquoteHTML + "</span>";
            icons.bold = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.bold') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.bold') + "\">" + boldHTML + "</span>";
            icons.color = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.textColor') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.textColor') + "\">" + fontColorHTML + "</span>";
            icons.clean = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.clearFormatting') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.clearFormatting') + "\">" + clearFormattingHTML + "</span>";
            icons.direction.rtl = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.direction') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.direction') + "\">" + directionHTML + "</span>";
            icons.direction[''] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.direction') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.direction') + "\">" + directionRTLHTML + "</span>";
            icons.image = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.image') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.image') + "\">" + imageHTML + "</span>";
            icons.indent['+1'] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.indent') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.indent') + "\">" + indentHTML + "</span>";
            icons.indent['-1'] = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.outdent') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.outdent') + "\">" + outdentHTML + "</span>";
            icons.italic = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.italic') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.italic') + "\">" + italicHTML + "</span>";
            icons.link = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.link') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.link') + "\">" + linkHTML + "</span>";
            icons.list.bullet = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.listUnordered') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.listUnordered') + "\">" + unorderedListHTML + "</span>";
            icons.list.ordered = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.listNumbered') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.listNumbered') + "\">" + orderedListHTML + "</span>";
            icons.history = {
              redo: "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.redo') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.redo') + "\">" + redoHTML + "</span>"
            };
            icons.script.sub = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.subscript') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.subscript') + "\">" + subscriptHTML + "</span>";
            icons.script.super = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.superscript') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.superscript') + "\">" + superscriptHTML + "</span>";
            icons.strike = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.strikethrough') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.strikethrough') + "\">" + strikethroughHTML + "</span>";
            icons.underline = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.underline') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.underline') + "\">" + underlineHTML + "</span>";
            icons.history.undo = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.undo') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.undo') + "\">" + undoHTML + "</span>";
            icons.video = "<span role=\"tooltip\" aria-label=\"" + edsContext.formatMessage('component.RichTextEditor.video') + "\" title=\"" + edsContext.formatMessage('component.RichTextEditor.video') + "\">" + videoHTML + "</span>";
            setIconsLoaded(true);
          case 97:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }, [edsContext]);
  var containerRef = useRef();

  // This code is from eee-dashboard; this automatically sets the editor to RTL if the context dir is RTL
  // This will only flip the direction of the first line within the quill editor
  // This function will not run when value or defaultValue exists
  useEffect(function () {
    if (dir === 'rtl' && !props.defaultValue && !props.value) {
      var _containerRef$current;
      var directionButton = containerRef == null ? void 0 : (_containerRef$current = containerRef.current) == null ? void 0 : _containerRef$current.querySelector('.ql-direction');
      directionButton == null ? void 0 : directionButton.click();
    }
  }, [dir, props.defaultValue, props.value]);

  // Changes the text alignment format button when the text direction button is not present
  useEffect(function () {
    var _containerRef$current2, _containerRef$current4;
    if (dir === 'rtl' && !(containerRef != null && (_containerRef$current2 = containerRef.current) != null && _containerRef$current2.querySelector('.ql-direction'))) {
      var _containerRef$current3;
      var rightAlignButton = containerRef == null ? void 0 : (_containerRef$current3 = containerRef.current) == null ? void 0 : _containerRef$current3.querySelector('.ql-align[value="right"]');
      rightAlignButton == null ? void 0 : rightAlignButton.click();
    } else if (dir === 'ltr' && !(containerRef != null && (_containerRef$current4 = containerRef.current) != null && _containerRef$current4.querySelector('.ql-direction'))) {
      var _containerRef$current5;
      var leftAlignButton = containerRef == null ? void 0 : (_containerRef$current5 = containerRef.current) == null ? void 0 : _containerRef$current5.querySelector('.ql-align[value=""]');
      leftAlignButton == null ? void 0 : leftAlignButton.click();
    }
  }, [dir]);

  /* #region link start */
  var _useState2 = useState(false),
    isLinkPopperOpen = _useState2[0],
    setLinkPopperOpen = _useState2[1];
  var _useState3 = useState(''),
    linkText = _useState3[0],
    setLinkText = _useState3[1];
  var _useState4 = useState(''),
    linkURL = _useState4[0],
    setLinkURL = _useState4[1];
  var _useState5 = useState(''),
    linkTarget = _useState5[0],
    setLinkTarget = _useState5[1];
  var _useState6 = useState(),
    returnEditorFocus = _useState6[0],
    setReturnEditorFocus = _useState6[1];
  function linkHandler() {
    var _blot$parent, _blot$parent$domNode, _blot$parent2, _blot$parent2$parent;
    // get the selected range, and from that range, get the selected blot
    var range = this.quill.getSelection(true);
    var _this$quill$getLeaf = this.quill.getLeaf(range.index + 1),
      blot = _this$quill$getLeaf[0];

    // populate the link text input field with the selected text
    setLinkText(this.quill.getText(range.index, range.length));

    // link blots are inline text
    // this means we need to get check the parent blots for a link element to populate the input field with the href
    if ((blot == null ? void 0 : (_blot$parent = blot.parent) == null ? void 0 : (_blot$parent$domNode = _blot$parent.domNode) == null ? void 0 : _blot$parent$domNode.tagName) === 'A') {
      setLinkURL(blot.parent.domNode.href);
      setLinkTarget(blot.parent.domNode.target);
    } else if ((blot == null ? void 0 : (_blot$parent2 = blot.parent) == null ? void 0 : (_blot$parent2$parent = _blot$parent2.parent) == null ? void 0 : _blot$parent2$parent.domNode.tagName) === 'A') {
      setLinkURL(blot.parent.parent.domNode.href);
      setLinkTarget(blot.parent.parent.domNode.target);
    } else {
      setLinkURL('');
      setLinkTarget('');
    }

    // return focus back to the editor if the user cancels the popper
    // is false when the user navigates down the page to the toolbar
    setReturnEditorFocus(this.quill.hasFocus());
    setLinkPopperOpen(true);
  }
  var setLinkUrl = function setLinkUrl(val) {
    var _blot$parent3, _blot$parent4, _blot$parent4$parent;
    // get the selected range
    var editor = quillRef.current.getEditor();
    var range = quillRef.current.getEditorSelection() || editor.getSelection(true);

    // get the selected blot and selection offset from the start of the blot
    var _editor$getLeaf = editor.getLeaf(range.index),
      blot = _editor$getLeaf[0],
      offset = _editor$getLeaf[1];
    var text = editor.getText(range.index, range.length);

    // check the parent blots for a link element
    var parentDomNodeTagName = (blot == null ? void 0 : (_blot$parent3 = blot.parent) == null ? void 0 : _blot$parent3.domNode.tagName) || (blot == null ? void 0 : (_blot$parent4 = blot.parent) == null ? void 0 : (_blot$parent4$parent = _blot$parent4.parent) == null ? void 0 : _blot$parent4$parent.domNode.tagName);

    // if the selected blot has a link element, delete the link element to be replaced with the new link
    if (parentDomNodeTagName === 'A') {
      var _blot$text;
      if (!val.title) {
        val.title = blot.parent.domNode.href || blot.parent.parent.domNode.href;
      }
      editor.deleteText(range.index - offset, (_blot$text = blot.text) == null ? void 0 : _blot$text.length, Quill.sources.USER);
    } else {
      if (!val.title) {
        val.title = val.url;
      }
      editor.deleteText(range.index, text.length, Quill.sources.USER);
    }

    // insert the link and reselect it
    // insertText(index: Number, text: String, format: String, value: any, source: String = 'api')
    editor.insertText(range.index - (parentDomNodeTagName === 'A' ? offset : 0), val.title, 'link', {
      href: val.url,
      target: val.target
    }, Quill.sources.USER);
    editor.setSelection(range.index - (parentDomNodeTagName === 'A' ? offset : 0), val.title.length);
    closeLinkPopper();
  };
  var closeLinkPopper = function closeLinkPopper() {
    setLinkPopperOpen(false);
    setLinkURL('');
    setLinkText('');
    setLinkTarget('');

    // return focus back to the editor if the user cancels the popper
    if (returnEditorFocus && !isImagePopperOpen) {
      setReturnEditorFocus(false);
      quillRef.current.getEditor().focus();
    }
  };

  /* #region link end */

  /* #region image start */
  var _useState7 = useState(false),
    isImagePopperOpen = _useState7[0],
    setImagePopperOpen = _useState7[1];
  var _useState8 = useState(''),
    imageAltText = _useState8[0],
    setImageAltText = _useState8[1];
  var _useState9 = useState(''),
    imageURL = _useState9[0],
    setImageURL = _useState9[1];
  function imageHandler() {
    var _blot$domNode;
    // get the selected range, and from that range, get the selected blot
    var range = this.quill.getSelection(true);
    var _this$quill$getLeaf2 = this.quill.getLeaf(range.index + 1),
      blot = _this$quill$getLeaf2[0];

    // get the blot's element tag name and check if we can populate the input fields
    var domNodeTagName = blot == null ? void 0 : (_blot$domNode = blot.domNode) == null ? void 0 : _blot$domNode.tagName;
    if (domNodeTagName === 'IMG') {
      setImageURL(blot.domNode.src);
      setImageAltText(blot.domNode.alt);
    } else {
      setImageAltText('');
      setImageURL('');
    }

    // return focus back to the editor if the user cancels the popper
    // is false when the user navigates down the page to the toolbar
    setReturnEditorFocus(this.quill.hasFocus());
    setImagePopperOpen(true);
  }
  var setImage = function setImage(val) {
    // get the selection range in the editor
    var editor = quillRef.current.getEditor();
    var range = quillRef.current.getEditorSelection() || editor.getSelection(true);

    // delete the selected content in the editor
    editor.deleteText(range.index, range.length, Quill.sources.USER);

    // insert the image
    editor.insertEmbed(range.index, 'image', {
      alt: "" + val.altText,
      url: "" + val.url
    }, Quill.sources.USER);
    closeImagePopper();
  };
  var closeImagePopper = function closeImagePopper() {
    setImagePopperOpen(false);
    setImageURL('');
    setImageAltText('');

    // return focus back to the editor once the popper is closed
    if (returnEditorFocus && !isLinkPopperOpen) {
      setReturnEditorFocus(false);
      quillRef.current.getEditor().focus();
    }
  };
  /* #region image end */

  /* #region video start */
  var _useState10 = useState(false),
    isVideoPopperOpen = _useState10[0],
    setVideoPopperOpen = _useState10[1];
  var _useState11 = useState(''),
    videoTitle = _useState11[0],
    setVideoTitle = _useState11[1];
  var _useState12 = useState(''),
    videoURL = _useState12[0],
    setVideoURL = _useState12[1];
  function videoHandler() {
    var _blot$domNode2;
    // get the selected range, and from that range, get the selected blot
    var range = this.quill.getSelection(true);
    var _this$quill$getLeaf3 = this.quill.getLeaf(range.index),
      blot = _this$quill$getLeaf3[0];

    // return focus back to the editor if the user cancels the popper
    // is false when the user navigates down the page to the toolbar
    setReturnEditorFocus(this.quill.hasFocus());

    // get the blot's element tag name and check if we can populate the input fields
    var domNodeTagName = blot == null ? void 0 : (_blot$domNode2 = blot.domNode) == null ? void 0 : _blot$domNode2.tagName;
    if (domNodeTagName === 'IFRAME') {
      setVideoURL(blot.domNode.src);
      setVideoTitle(blot.domNode.title);
    } else {
      setVideoTitle('');
      setVideoURL('');
    }
    setVideoPopperOpen(true);
  }
  var setVideo = function setVideo(val) {
    // get the selection range in the editor
    var editor = quillRef.current.getEditor();
    var range = quillRef.current.getEditorSelection() || editor.getSelection(true);

    // delete the selected content in the editor
    editor.deleteText(range.index, range.length, Quill.sources.USER);

    // insert the video
    editor.insertEmbed(range.index, 'video', {
      title: "" + val.title,
      url: "" + val.url
    }, Quill.sources.USER);
    closeVideoPopper();
  };
  var closeVideoPopper = function closeVideoPopper() {
    setVideoPopperOpen(false);
    setVideoURL('');
    setVideoTitle('');

    // return focus back to the editor once the popper is closed
    if (returnEditorFocus && !isVideoPopperOpen) {
      setReturnEditorFocus(false);
      quillRef.current.getEditor().focus();
    }
  };

  /* #region video end */

  /* #region autoformatLinks start */
  var urlPattern = /(?:\s|^)(https?:\/\/[^\s]+)/;
  var globalUrlPattern = /https?:\/\/[^\s]+/g;
  var sliceUrl = function sliceUrl(url) {
    // slice url at the last instance of any whitespace
    var index = url.lastIndexOf(' ');
    var sliceIndex = index === -1 ? 0 : index + 1;
    var slicedUrl = url.slice(sliceIndex);
    return slicedUrl;
  };
  var bindings = {
    autoLinksSpace: {
      collapsed: true,
      key: ' ',
      prefix: urlPattern,
      // prefix matches the text immediately preceding the user’s selection’s start position
      handler: function handler(range, context) {
        // get the url from context.prefix
        var url = sliceUrl(context.prefix);

        // retain the contents after the sliced whitespace
        var retain = range.index - url.length;

        // add operations for formatting the url into a hyperlink
        var delta = new Delta().retain(retain).delete(url.length).insert(url, {
          link: {
            href: url
          }
        });
        this.quill.updateContents(delta, Quill.sources.USER);

        // updateContents uses Quill's Delta API to batch update contents
        this.quill.updateContents(delta);
        return true; // returning true allows other handlers to propagate
      }
    },

    autoLinksEnter: {
      collapsed: true,
      key: 'Enter',
      prefix: urlPattern,
      // prefix matches the text immediately preceding the user’s selection’s start position
      handler: function handler(range, context) {
        // get the url from context.prefix
        var url = sliceUrl(context.prefix);

        // retain the contents after the sliced whitespace
        var retain = range.index - url.length;

        // add operations for formatting the url into a hyperlink
        var delta = new Delta().retain(retain).delete(url.length).insert(url, {
          link: {
            href: url
          }
        });
        this.quill.updateContents(delta, Quill.sources.USER);

        // updateContents uses Quill's Delta API to batch update contents
        this.quill.updateContents(delta);
        return true; // returning true allows other handlers to propagate
      }
    },

    tab: {
      // must be named tab in order to override Quill's default tab handler
      key: 'Tab',
      handler: function handler(range, context) {
        // part of Quill's default tab handler
        if (context.format.table) {
          return true;
        }
        if (urlPattern.test(context.prefix)) {
          // get the url from context.prefix
          var url = sliceUrl(context.prefix);

          // retain the contents after the sliced whitespace
          var retain = range.index - url.length;

          // add operations for formatting the url into a hyperlink
          var delta = new Delta().retain(retain).delete(url.length).insert(url, {
            link: {
              href: url
            }
          }).insert('\t');
          this.quill.updateContents(delta, Quill.sources.USER);
        } else {
          // Quill's default tab handler
          this.quill.history.cutoff();
          var _delta = new Delta().retain(range.index).delete(range.length).insert('\t');
          this.quill.updateContents(_delta, Quill.sources.USER);
          this.quill.history.cutoff();
          this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
          return false;
        }
      }
    }
  };

  /**
   * Interprets pasted clipboard and matches the contents to automatically convert URLs into hyperlinks
   * @param {*} node DOM Node of the parsed HTML contents from the clipboard
   * @param {*} delta Delta object with the list of editor operations to paste the respective node
   * @returns delta - delta param with updated operations if a url is present in the contents
   */
  var autoLinkClipboard = function autoLinkClipboard(node, delta) {
    // skip if node is not text
    if (typeof node.data !== 'string') {
      return;
    }

    // globally match all the urls in the clipboard text
    var matches = node.data.match(globalUrlPattern);
    if (matches && matches.length > 0) {
      var operations = [];
      var str = node.data;
      matches.forEach(function (match) {
        // split the matched text
        var split = str.split(match);
        var beforeLink = split.shift();

        // add operations for formatting the url into a hyperlink
        operations.push({
          insert: beforeLink
        });
        operations.push({
          insert: match,
          attributes: {
            link: {
              href: match
            }
          }
        });
        str = split.join(match);
      });
      operations.push({
        insert: str
      });
      delta.ops = operations;
    }
    return delta;
  };

  /**
   * Interprets pasted hyperlinks to ensure the target attribute is added to the link
   * @param {*} node DOM Node of the parsed HTML contents from the clipboard
   * @param {*} delta Delta object with the list of editor operations to paste the respective node
   * @returns delta - delta param with updated operations if a target is added to the link
   */
  var linkMatcher = function linkMatcher(node, delta) {
    if (node.getAttribute('target')) {
      // search the list of delta operations for a link
      delta.ops.forEach(function (operation, index) {
        if (operation != null && operation.attributes && 'link' in operation.attributes) {
          // add the hyperlink's target to the list of link attributes in the delta operation
          if (typeof operation.attributes.link === 'object') {
            delta.ops[index].attributes.link['target'] = node.getAttribute('target');
          } else {
            delta.ops[index].attributes.link = {
              href: node.getAttribute('href'),
              target: node.getAttribute('target')
            };
          }
        }
      });
    }
    return delta;
  };
  /* #region autoformatLinks end */

  /* #region undo/redo start */
  function historyHandler(value) {
    // value is from the key-value pair used to define the toolbar button
    if (value === 'undo') {
      // undoes the last operation; operation source is USER
      this.quill.history.undo();
    } else if (value === 'redo') {
      // redoes the last operation; operation source is USER
      this.quill.history.redo();
    }
  }
  /* #region undo/redo end */

  var modules = useMemo(function () {
    var toolbar = {
      container: toolbarProp || defaultToolbar,
      handlers: {
        link: linkHandler,
        image: imageHandler,
        video: videoHandler,
        history: historyHandler
      }
    };
    return {
      toolbar: toolbar,
      imageResize: {
        modules: ['Resize', 'DisplaySize']
      },
      keyboard: {
        bindings: bindings
      },
      // ReactQuill calls the clipboard API on initial render to set the contents of the editor
      // this means that any matchers or clipboard configuration options will apply on initial render
      clipboard: {
        matchers: [[Node.TEXT_NODE, autoLinkClipboard], ['a', linkMatcher]],
        /**
         * This configuration option is not found in the Quill public documentation site
         * see https://github.com/quilljs/quill/blob/1.3.7/docs/docs/modules/clipboard.md#matchvisual
         *
         * Overrides Quill's "visual" interpretation of margin and padding from pasted text to use the
         * exact HTML value. Prevents line-break duplication on initial render.
         */
        matchVisual: false
      }
    };
  }, []);
  return iconsLoaded && /*#__PURE__*/React.createElement("div", {
    ref: containerRef
  }, /*#__PURE__*/React.createElement(ReactQuill, _extends({
    ref: quillRef,
    className: cn(classes.root, className, classes.translations, "ql-locale-" + edsContext.locale, {
      'ql-snow-rtl': dir === 'rtl'
    }),
    theme: "snow",
    modules: modules
  }, rest)), /*#__PURE__*/React.createElement(LinkPopper, {
    isPopperOpen: isLinkPopperOpen,
    onInsertLink: setLinkUrl,
    onClose: closeLinkPopper,
    title: linkText,
    url: linkURL,
    target: linkTarget,
    isEdit: !(linkText === '' && linkURL === ''),
    edsContext: edsContext,
    containerRef: containerRef
  }), /*#__PURE__*/React.createElement(ImagePopper, {
    isPopperOpen: isImagePopperOpen,
    onInsertImage: setImage,
    onClose: closeImagePopper,
    altText: imageAltText,
    url: imageURL,
    isEdit: !(imageAltText === '' && imageURL === ''),
    edsContext: edsContext,
    containerRef: containerRef
  }), /*#__PURE__*/React.createElement(VideoPopper, {
    isPopperOpen: isVideoPopperOpen,
    onInsertVideo: setVideo,
    onClose: closeVideoPopper,
    title: videoTitle,
    url: videoURL,
    isEdit: !(videoTitle === '' && videoURL === ''),
    edsContext: edsContext,
    containerRef: containerRef
  }));
});
RichTextEditor.displayName = 'RichTextEditor';
RichTextEditor.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The HTML `id` to be applied to the DOM element.
   */
  id: PropTypes.string,
  /**
   * Class name to be applied to the DOM element.
   */
  className: PropTypes.string,
  /**
   * Initial value for the editor as an uncontrolled component. Can be a string containing HTML.
   */
  defaultValue: PropTypes.string,
  /**
   * @ignore
   */
  edsContext: PropTypes.object,
  /**
   * An array specifying the toolbar options.
   */
  toolbar: PropTypes.array,
  /**
   * (content)
   *
   * Called back with the new contents of the editor after change. It will be passed the HTML contents of the editor.
   */
  onChange: PropTypes.func,
  /**
   * The default value for the empty editor.
   *
   * Note: We do not support changing this value dynamically. Use refs and data-attributes instead (see Developers Notes, above, for details)
   */
  placeholder: PropTypes.string,
  /**
   * If `true`, a `pre` tag is used for the editor area instead of the default `div` tag.
   *
   * This prevents the Rich Text Editor from collapsing continuous whitespaces on paste.
   */
  preserveWhitespace: PropTypes.bool,
  /**
   * If `true`, the editor won't allow changing its contents.
   */
  readOnly: PropTypes.bool,
  /**
   * An object with custom CSS rules to apply on the editor's container.
   */
  style: PropTypes.object,
  /**
   * The order in which the editor becomes focused, among other controls in the page, during keyboard navigation.
   */
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * @ignore
   * The name of the theme to apply to the editor. Defaults to `snow`, Quill's standard theme.
   * Pass `null` to use the minimal core theme. See the docs on themes for more information on
   * including the required stylesheets.
   */
  theme: PropTypes.string,
  /**
   * Value for the editor as a controlled component. Can be a string containing HTML
   */
  value: PropTypes.any
};
RichTextEditor.defaultProps = {
  preserveWhitespace: false,
  readOnly: false
};
export default withEDSContext(withStyles(styles, {
  index: 0
})(RichTextEditor));